angular.module("Finance")
    .controller("auditController", [
        "$scope", "$sessionStorage", "$http", "$activity", "$fileService", "$oidc", "$notification",
        function ($scope, $sessionStorage, $http, $activity, $fileService, oidc, $notification) {

            $scope.auditDay = null;

            function removeTime(date = new Date()) {
                return new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate()
                );
            }

            // Storage
            $scope.$storage = $sessionStorage.$default({
                audit: {
                    numberFrom: null,
                    numberTo: null,
                    dateFrom: null,
                    dateTo: null
                }
            });

            // Date pickers
            $scope.fromOpen = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $scope.fromOpened = true;
            };

            // $scope.toOpen = function ($event) {
            //     $event.preventDefault();
            //     $event.stopPropagation();

            //     $scope.toOpened = true;
            // };

            // Generate pdf export
            $scope.generatePdfExport = function () {
                $activity.start();

                if ($scope.auditDay != null) {

                    var dateForm = removeTime($scope.auditDay);
                    var dateTo = new Date(dateForm);
                    dateTo.setDate(dateTo.getDate() + 1);

                    $http
                        .get("/api/audit/exportpdf/", {
                            params: {
                                numberFrom: $scope.$storage.audit.numberFrom,
                                numberTo: $scope.$storage.audit.numberTo,
                                dateFrom: dateForm,
                                dateTo: dateTo
                            },
                            responseType: "arraybuffer",
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $fileService.saveResponseToFile(response);
                        }, function (response) {
                            $notification.addError(response.statusText);
                        }).then(function () {
                            $activity.finish();
                        });
                }
            };

            // Generate xml export
            $scope.generateXmlExport = function () {
                $activity.start();

                if ($scope.auditDay != null) {

                    var dateForm = removeTime($scope.auditDay);
                    var dateTo = new Date(dateForm);
                    dateTo.setDate(dateTo.getDate() + 1);

                    $http
                    .get("/api/audit/exportxml/", {
                        params: {
                            numberFrom: $scope.$storage.audit.numberFrom,
                            numberTo: $scope.$storage.audit.numberTo,
                            dateFrom: dateForm,
                            dateTo: dateTo
                        },
                        responseType: "arraybuffer",
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $fileService.saveResponseToFile(response);
                    }, function (response) {
                        $notification.addError(response.statusText);
                    }).then(function () {
                        $activity.finish();
                    });
                }
            };
        }
    ]);